import merge from 'lodash/merge'
import api from '@/api'
import store from '@/store'
import D2C_Entity from './Entity'

class D2C_Project extends D2C_Entity {
  target = 'project'
  hasPage = true
  icon = 'folder'
  static objectType = 'entityType'
  static typeName = 'project'
  static color = '#ffdd66'
  static fields = {
    ...D2C_Entity.fields,
    name: {
      autoselect: true,
      default: '',
      label: 'Name',
      path: 'name',
      required: true,
      validate(value, entity) {
        const regexp = /^[^"'`~%^(){}+<>?]{1,50}$/
        if (!entity.created && store.getters.projectsByName[value]) {
          return 'This name is already used'
        }
        if (!regexp.test(value)) {
          return 'Invalid name'
        }
        return (value && value.length > 0) ? null : 'Must be filled'
      },
      creating: {},
      updating: {},
      renaming: {},
    },
    rules: {
      default: {
        global: [],
        local: [],
      },
      label: 'Rules',
      validate() {
        return null
      },
      updatingAccess: {}
    },
  }
  static create(props) {
    return new D2C_Project(props)
  }
  get _actions() {
    const role = store.getters.role
    const member = store.getters.member
    const rules = {}
    const actions = ['projectInfo', 'projectUpdate', 'projectUsage', 'projectDestroy', 'serviceInfo', 'serviceUpdate', 'serviceTerminal', 'serviceMoveContainer', 'serviceScale', 'serviceChangeProject', 'serviceDestroy']
    for (const action of actions) {
      rules[action] = member.isOwner ? 1 : merge(
        {result: (this.rules.global[role.id] || {actions: {}}).actions[action]},
        {result: (this.rules.global[member.id] || {actions: {}}).actions[action]},
        {result: (this.rules.local[role.id] || {actions: {}}).actions[action]},
        {result: (this.rules.local[member.id] || {actions: {}}).actions[action]}
      ).result
    }
    return rules
  }
  get _path() {
    return this.id && this.name ? `/projects/${encodeURIComponent(this.name)}` : null
  }
  get _containers() {
    return store.getters.containersByProject[this.id] || []
  }
  get _hosts() {
    return store.getters.hostsByProject[this.id] || []
  }
  get _services() {
    return store.getters.servicesByProject[this.id] || []
  }
  create() {
    return api.createProject(this.getValues('creating'))
  }
  update() {
    return api.updateProject(this.id, this.getChanges())
  }
  destroy() {
    return api.destroyProject(this.id)
  }
  updateRules(newRules) {
    return api.updateProjectRules(this.id, newRules || this.rules)
  }
}

export default D2C_Project
